import GeoSearchSelectMenu from "@/app/components/ui/SelectMenus/GeoSearchSelectMenu";
import { INearbyLocationSearchProps } from "@/app/components/routes/auth_routes/SlotsScreen/BookingFiltersComponent/interface";

const NearbyLocationSearch: React.FC<INearbyLocationSearchProps> = ({
  formHook,
  disableSlotsFilter,
  handleNearbyLocationSelect,
  handleNearbyLocationClear,
}) => {
  return (
    <GeoSearchSelectMenu
      autoComplete="off"
      autoCorrect="false"
      withClearAction
      disabled={disableSlotsFilter}
      disableSearch={disableSlotsFilter}
      clearSearch={formHook?.getValues("city") !== ""}
      skipDefaultPrefill
      showDropdownWhenNoData
      labelInfo="You can search by nearest location and all the clinics will be fetched."
      onSelectItem={handleNearbyLocationSelect}
      containerClassName="w-full"
      errorMessages={[]}
      fieldError={formHook.formState.errors.lat}
      register={formHook.register("locationId", {
        required: false,
      })}
      onClear={handleNearbyLocationClear}
      showTypedErrors={false}
      placeholder="Search Nearby Location"
    />
  );
};

export default NearbyLocationSearch;
